import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { acceptOrRejectPartnerConnectionService, removePartnerService, sharingCodeValidateService, } from 'Services/libre_api';
const useLibrePartner = () => {
    const removePartner = useCallback(async (partnerID) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        return removePartnerService(partnerID, user.id, osType, osVersion, app, appVersion);
    }, []);
    const showStopSharingModal = useCallback((partnerName, titleTextKey, bodyTextKey, onRemoveClick) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
                buttonLayout: 'column',
                details: (React.createElement(Stack, null,
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.strong", fontSize: "$bodyBase.strong", testID: "StopSharingModal.title", marginBottom: "$4" }, i18n.t(titleTextKey)),
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default", testID: "StopSharingModal.body" }, i18n.t(bodyTextKey, {
                        partnerName,
                    })))),
                primaryAction: {
                    label: i18n.t('Global.modals.stopSharing.title'),
                    destructive: true,
                    onPress: () => {
                        store.dispatch({
                            type: CLOSE_MODAL,
                        });
                        onRemoveClick();
                    },
                },
                secondaryAction: {
                    label: i18n.t('Global.microcopy.common.cancel'),
                    onPress: () => store.dispatch({
                        type: CLOSE_MODAL,
                    }),
                },
                testID: 'StopSharingModal',
            },
        });
    }, []);
    const sharingCodeValidate = useCallback(async (code, yearOfBirth) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            const { partnerId } = await sharingCodeValidateService(code, yearOfBirth, user.id, osType, osVersion, app, appVersion);
            return { partnerId };
        }
        catch (err) {
            const error = err;
            const errorCode = error.response?.data.code;
            if (error.response?.headers['x-attempts-remaining']) {
                const attemptsRemaining = Number(error.response.headers['x-attempts-remaining']);
                if (attemptsRemaining === 0) {
                    return { errorCode, reachedMaxYobAttempts: true };
                }
            }
            return { errorCode };
        }
    }, []);
    const acceptOrRejectPartnerConnection = useCallback(async (partnerID, action, code, yearOfBirth) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            await acceptOrRejectPartnerConnectionService(partnerID, user.id, action, osType, osVersion, app, appVersion, code, yearOfBirth);
            return {};
        }
        catch (err) {
            const error = err;
            return { error };
        }
    }, []);
    return {
        removePartner,
        showStopSharingModal,
        acceptOrRejectPartnerConnection,
        sharingCodeValidate,
    };
};
export default useLibrePartner;
